import {
  CheckMetadata,
  CheckMetadataItem,
  CheckMetadataItemType,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { SelfieAgeComparison } from 'dashboard/models/check';

export const computeSelfieAgeComparisonMetadata = (check: SelfieAgeComparison): CheckMetadata => {
  const metadata = [] as CheckMetadataItem[];

  if (check.metadata) {
    const risks = check.metadata ? check.metadata['risks'] : null;
    const ageMismatchRiskData = risks?.find((r) => r.reason === 'age_mismatch');

    const {
      'min-age-limit': minAgeLimit,
      'max-age-limit': maxAgeLimit,
      'confidence-below-age-limit': confidenceBelowAgeLimit,
      'confidence-above-age-limit': confidenceAboveAgeLimit,
    } = check.metadata || {};
    const mismatchRiskLevel = ageMismatchRiskData && ageMismatchRiskData.level;

    const showMinAgeComparison = confidenceBelowAgeLimit != null && minAgeLimit != null;
    const showMaxAgeComparison = confidenceAboveAgeLimit != null && maxAgeLimit != null;
    if (showMinAgeComparison || showMaxAgeComparison) {
      const ageThresholdComparisonItems = [];
      if (showMinAgeComparison) {
        ageThresholdComparisonItems.push({
          label: 'Minimum Age',
          value: `${minAgeLimit} years old`,
        });
        ageThresholdComparisonItems.push({
          label: 'Confidence Face Age Below Min Limit',
          value: `${(confidenceBelowAgeLimit * 100).toFixed(2)}%`,
        });
      }
      if (showMaxAgeComparison) {
        ageThresholdComparisonItems.push({
          label: 'Maximum Age',
          value: `${maxAgeLimit} years old`,
        });
        ageThresholdComparisonItems.push({
          label: 'Confidence Face Age Above Max Limit',
          value: `${(confidenceAboveAgeLimit * 100).toFixed(2)}%`,
        });
      }

      metadata.push({
        type: CheckMetadataItemType.Group,
        heading: {
          title: 'Age Threshold Comparison Risk',
        },
        items: ageThresholdComparisonItems,
      });
    }

    if (mismatchRiskLevel) {
      metadata.push({
        type: CheckMetadataItemType.Group,
        heading: {
          title: 'Age Inconsistency Detection Risk',
        },
        items: [
          {
            label: 'Risk Level',
            value: RiskLevelSticker({ riskLevel: mismatchRiskLevel }),
          },
        ],
      });
    }
  }

  return {
    metadata,
    hideIfVerificationPassed: false,
  };
};
